import React, { Component } from 'react';
import {
    Container, Row, Col, Button
} from 'reactstrap';
import ItemProducto from '../../../itemProducto';
import FormProducto from '../formProducto';
import Producto from '../../../utilitarios/producto';
import './editarProd.css';
const prod = new Producto()

export default class EditarProducto extends Component {
    constructor(props) {
        super(props)

        this.state = {
            producto: this.props.producto,
            ImgProgress: 0
        }
        this.editarProducto = this.editarProducto.bind(this)
        this.guardarCambios = this.guardarCambios.bind(this)
        this.guardarImagen = this.guardarImagen.bind(this)
        this.actualizarImgProgress = this.actualizarImgProgress.bind(this)
        this.getImgUrl = this.getImgUrl.bind(this)
    }

    editarProducto(producto) {
        // console.log('Agotado', producto.Agotado)
        this.setState({
            producto
        })
    }

    guardarCambios(e) {
        e.preventDefault()
        prod.guardarProducto(this.state.producto)
        this.props.atras()
    }

    guardarImagen(e) {
        const file = e.target.files[0]
        const reg = /(.*?)\.(jpg|bmp|jpeg|png)$/
        console.log(file)
        if (!file.name.match(reg)) {
            alert("Archivo no válido")
            return false
        }
        const descripcion = `${Date.now()}.${file.name.slice((file.name.lastIndexOf(".") - 1 >>> 0) + 2)}`
        prod.subirImagenProducto(file, descripcion, this.actualizarImgProgress, this.getImgUrl)
    }

    actualizarImgProgress(ImgProgress) {
        this.setState({
            ImgProgress
        })
    }

    getImgUrl(Img) {
        this.setState({
            producto: {
                ...this.state.producto,
                Img
            },
            ImgProgress: 0
        })
    }


    render() {
        return (
            <Container className="containerAdmin">
                <Button
                    onClick={this.props.atras}
                    color="warning"
                >
                    Atrás
                </Button>
                <Row className="rowEdicion">
                    <Col md={6}>
                        <FormProducto producto={this.state.producto} editarProducto={this.editarProducto} guardarCambios={this.guardarCambios} guardarImagen={this.guardarImagen} ImgProgress={this.state.ImgProgress} />
                    </Col>
                    <Col md={3}>
                        <ItemProducto
                            producto={this.state.producto}
                        />
                    </Col>
                </Row>

            </Container>
        )
    }


}